import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'ui-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackToTopComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class.d-print-none') readonly printHidden = true;

  @ViewChild('sentinel', { static: true })
  sentinel!: ElementRef<HTMLDivElement>;

  visible = false;

  private observer?: IntersectionObserver;

  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    const parent = this.host.nativeElement.parentElement;
    parent?.insertBefore(this.sentinel.nativeElement, parent.firstChild);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.visible = !entry.isIntersecting;
        this.cdr.markForCheck();
      },
      { threshold: 0 }
    );
    this.observer.observe(this.sentinel.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  scrollToTop(): void {
    const behavior: ScrollBehavior = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
      ? 'auto'
      : 'smooth';

    window.scrollTo({ top: 0, behavior });
    document.querySelector<HTMLElement>('h1')?.focus({ preventScroll: true });
  }
}
